import { useTranslation } from 'next-i18next'
// Libs
import styled, { css } from 'styled-components'

// Comps.
import { Section } from '../Section'
import { colors, mobileScreen, fontWeights } from '../../utils'
import { H2, H4 } from '../Headings'

// Defs
type Question = {
  question: string
  answer: React.ReactNode
}

export type Faqs = Question[]

interface Props {
  className?: string
  questions?: Faqs
}

// Styles
const Container = styled(Section)`
  width: 100%;
  max-width: 660px;
  margin: auto;

  h2 {
    margin-top: unset;
  }
  h4 {
    margin-top: 40px;
  }
  h4 + p {
    margin-top: 20px;
  }
  p + p {
    margin-top: 15px;
  }
  p + .spacer {
    margin-top: 40px;
  }

  .spacer {
    width: 100%;
    border-bottom: 1px solid #000000;
    opacity: 0.1;
  }

  a {
    font-weight: ${fontWeights.bold};
    color: ${colors.offBlack};
  }
`

export const FaqSection: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Props
  const { questions, className } = props
  const faqs: Faqs = questions || []

  // ..
  return (
    <Container className={`FaqSection ${className || ''}`}>
      <H2>{t(`FAQs`, `FAQs`)}</H2>
      {faqs.map((faq, index) => {
        const { question, answer } = faq
        return (
          <article key={index}>
            <H4>{question}</H4>
            {answer}
            <div className="spacer" />
          </article>
        )
      })}
    </Container>
  )
}
